<script>
  export let title = "";
  export let description = "";
  export let note = "";
  export let noteLabel = "";
  export let variant = "default";
  export let contextLabel = "";
  export let contextValue = "";
  export let showNote = true;
</script>

<section class="survey_step_intro {variant}">
  <div class="intro_heading">
    <div>
      {#if variant === "welcome"}
        <p class="intro_eyebrow">Welcome to our survey</p>
      {/if}
      <h5>{title}</h5>
      {#if variant === "detail" && (contextLabel || contextValue)}
        <p class="detail_context"><span>{contextValue}</span><b>{contextLabel}</b></p>
      {/if}
    </div>
    <slot name="action" />
  </div>

  {#if description}
    <div class="intro_text">
      <p>{@html description}</p>
    </div>
  {/if}

  {#if showNote && note}
    <div class="intro_note">
      <p>{noteLabel ? `${noteLabel}: ${note}` : note}</p>
    </div>
  {/if}
</section>

<style>
  .survey_step_intro {
    width: 100%;
    margin-bottom: 1.25rem;
  }

  .intro_heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding-bottom: 1rem;
  }

  .intro_heading > div {
    min-width: 0;
  }

  .intro_heading h5 {
    max-width: 100%;
    height: auto;
    margin: 0;
    color: #59616c;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.35;
    overflow-wrap: break-word;
    white-space: normal;
  }

  .intro_text {
    padding: 0;
    color: #59616c;
    line-height: 1.55;
  }

  .intro_text p {
    margin: 0;
    font-size: 1rem !important;
    font-weight: 400;
    color: var(--pax-black);
  }

  .intro_text :global(strong) {
    color: var(--pax-black);
    font-weight: 700;
  }

  .intro_note {
    position: relative;
    width: fit-content;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0.85rem 0 0;
    padding: 0.85rem 1rem;
    border: 1px solid #e2e5e9;
    border-radius: 0.5rem;
    background: #fafafa;
    color: #59616c;
  }

  .intro_note p {
    margin: 0;
    font-size: 0.9rem !important;
    line-height: 1.45;
  }

  .intro_eyebrow {
    display: block;
    width: max-content;
    margin: 0 0 1rem;
    padding: 0.25rem 0.65rem;
    border-radius: 999px;
    background: var(--pax-blue);
    color: var(--pax-black);
    font-size: 0.72rem;
    font-weight: 700;
  }

  .dimension .intro_heading {
    display: block;
    padding-bottom: 0.7rem;
  }

  .dimension .intro_heading h5,
  .focus .intro_heading h5 {
    color: #59616c;
    font-size: 1rem;
    font-weight: 400;
    letter-spacing: 0;
    text-transform: none;
  }

  .dimension .intro_text p,
  .focus .intro_text p {
    color: var(--pax-black);
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 1.45;
  }

  .focus .intro_heading {
    padding-bottom: 0.65rem;
  }

  .focus .intro_note {
    max-width: 34rem;
    margin: 0.85rem 0 1rem;
  }

  .detail_context {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    margin: 0.5rem 0 0;
    color: #59616c;
    font-size: 0.82rem;
  }

  .detail_context span {
    color: var(--pax-black);
    font-weight: 650;
  }

  .detail_context b {
    font-weight: 500;
  }
</style>
